import { ErrorMessage, Field } from "formik";
import React from "react";
import { cn } from "../lib/utils";

const FormField = ({
  name,
  label,
  icon,
  type = "text",
  as,
  rows,
  help = "",
  children,
  required = false,
}) => {
  return (
    <div className="flex flex-col gap-1.5">
      {/* Label */}
      <label
        htmlFor={name}
        className="flex items-center gap-2 text-sm font-semibold cursor-pointer select-none"
      >
        {icon &&
          React.createElement(icon, {
            className: "h-4 w-4 shrink-0",
            style: { color: "var(--acc)" },
          })}
        {label}
        {required && <span style={{ color: "var(--req)" }} className="font-bold">*</span>}
      </label>

      {/* Info toujours visible, plus de tooltip caché */}
      {help && <p className="field-hint">{help}</p>}

      {/* Input / Textarea */}
      <Field name={name}>
        {({ field, meta }) => {
          const hasError = meta.touched && meta.error;

          if (as === "textarea") {
            return (
              <textarea
                id={name}
                rows={rows || 2}
                className={cn("field-input", hasError && "has-error")}
                {...field}
              />
            );
          }

          return (
            <input id={name} type={type} className={cn("field-input", hasError && "has-error")} {...field}>
              {children}
            </input>
          );
        }}
      </Field>

      <ErrorMessage name={name} component="p" className="field-err" />
    </div>
  );
};

export default FormField;
